import React from "react";

const RightArrowIcon = () => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.29592 6.48928L1.68321 11.102C1.55322 11.232 1.37693 11.305 1.19311 11.305C1.00928 11.305 0.832989 11.232 0.703006 11.102C0.573023 10.972 0.5 10.7957 0.5 10.6119C0.5 10.4281 0.573023 10.2518 0.703006 10.1218L4.82619 5.99975L0.70416 1.87657C0.639799 1.81221 0.588745 1.7358 0.553913 1.65171C0.519081 1.56762 0.501153 1.47749 0.501153 1.38647C0.501153 1.29545 0.519081 1.20532 0.553913 1.12123C0.588745 1.03713 0.639799 0.960727 0.70416 0.896366C0.768521 0.832005 0.844928 0.780951 0.92902 0.746119C1.01311 0.711287 1.10324 0.693359 1.19426 0.693359C1.28528 0.693359 1.37541 0.711287 1.4595 0.746119C1.54359 0.780951 1.62 0.832005 1.68436 0.896366L6.29707 5.50908C6.3615 5.57343 6.41259 5.64988 6.44741 5.73402C6.48224 5.81816 6.50011 5.90835 6.5 5.99942C6.49989 6.09048 6.48181 6.18063 6.44679 6.26469C6.41177 6.34875 6.3605 6.42507 6.29592 6.48928Z"
        fill="black"
      />
    </svg>
  );
};

export default RightArrowIcon;
